export enum TabValues {
    Catalog = 'catalog',
    Review = 'review',
    Completed = 'completed',
}
